// extracted by mini-css-extract-plugin
module.exports = {"form":"my-data_form__eHuLg","emailText":"my-data_emailText__x7cco","rowSplit":"my-data_rowSplit__JzrZH"};